/**
 * Created by karthikeyan.k on 07-12-2018.
 */
export class TutorialConstant {
  public static get FC21() {
    return {
      image_background: 'Tutorial_Background@2x.webp',
      image_0: 'Tutorial_00_Index@2x.webp',
      image_1: 'Tutorial_01_Introduction@2x.webp',
      image_2: 'Tutorial_02_Scores@2x.webp',
      image_3: 'Tutorial_03_GameAction@2x.webp',
      image_4: 'Tutorial_04_GameRules@2x.webp',
      image_5: 'Tutorial_05_Soft17@2x.webp',
      image_6: 'Tutorial_06_StartAGame@2x.webp',
      image_7: 'Tutorial_07_NaturalHands@2x.webp',
      image_8: 'Tutorial_08_SNWins@2x.webp',
      image_9: 'Tutorial_09_N21Wins@2x.webp',
      image_10: 'Tutorial_10_DNWins@2x.webp',
      image_11: 'Tutorial_11_NZWins@2x.webp',
      image_12: 'Tutorial_12_BustOver22@2x.webp',
      image_13: 'Tutorial_13_Splits@2x.webp',
      image_14: 'Tutorial_14_ImpossibleSplits@2x.webp',
      image_15: 'Tutorial_15_DoubleDown@2x.webp',
      image_16: 'Tutorial_16_ColorInsurance@2x.webp',
      image_17: 'Tutorial_17_WhiteInsurance@2x.webp',
      image_18: 'Tutorial_18_Russian_Roulette@2x.webp',
      image_19: 'Tutorial_19_PremiumPayouts@2x.webp',
      image_20: 'Tutorial_AboutUs@2x.webp',
      image_21: 'Tutorial_QuickKeys@2x.webp',
    };
  }

  public static get FCB() {
    return {
      image_background: 'fcb_tutorials_00_Gold_Underlay@2x.webp',
      image_0: 'fcb_tutorials_01_Index@2x.webp',
      image_1: 'fcb_tutorials_02_Full_Color_Cards@2x.webp',
      image_2: 'fcb_tutorials_03_Scores@2x.webp',
      image_3: 'fcb_tutorials_04_Ways_to_Win@2x.webp',
      image_4: 'fcb_tutorials_05_Game_Rules@2x.webp',
      image_5: 'fcb_tutorials_06_Hand_Scoring@2x.webp',
      image_6: 'fcb_tutorials_07_Deal_Scoring@2x.webp',
      image_7: 'fcb_tutorials_08_Draw_Scoring@2x.webp',
      image_8: 'fcb_tutorials_09_Spread_Banker_Chases_Player@2x.webp',
      image_9: 'fcb_tutorials_10_Spread_Player_Chases_Banker@2x.webp',
      image_10: 'fcb_tutorials_11_Spread_Dual_Chase@2x.webp',
      image_11: 'fcb_tutorials_12_Spread_Game_Over@2x.webp',
      image_12: 'fcb_tutorials_13_Tie_Game_Rules@2x.webp',
      image_13: 'fcb_tutorials_14_Commission_Rules@2x.webp',
      image_14: 'fcb_tutorials_15_Side_Bets@2x.webp',
      image_15: 'fcb_tutorials_16_Session_Bets@2x.webp',
      image_16: 'fcb_tutorials_17_Live_Side_Bets@2x.webp',
      image_17: 'fcb_tutorials_18_Raw_Scores_and_Hand_Ranks@2x.webp',
      image_18: 'fcb_tutorials_19_Road_Maps@2x.webp',
      image_19: 'fcb_tutorials_20_Quick_Keys@2x.webp',
      image_20: 'fcb_tutorials_21_Game_Summary@2x.webp',
    };
  }

  public static get FCBPREMIUMPAY() {
    return 13;
  }

  public static get FC21PREMIUMPAY() {
    return 8;
  }

  public static get FCBQUICKKEYS() {
    return 19;
  }

  public static get FC21QUICKKEYS() {
    return 19;
  }
}
